import { Api_routes, server_url } from '../config/API_Routes';
import { getRequest, patchRequest, postRequest } from '../config/axios-config';

const createTag = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.createTag,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getAllTagsByUserId = () => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.getAllTagsByUserId
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const updateTag = (tagId, body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.updateTag + '/' + tagId,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const deleteTag = (tagId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.deleteTag + '/' + tagId
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const addTagForInfluencer = (tagId, influencerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.addTagForInfluencer +
          '/' +
          tagId +
          '/' +
          influencerId
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const bulkTagInfluencers = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await postRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.addBulkTagsToInfluencersV2,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const getAllTagsByInfluencerId = (influencerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await getRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.getAllTagsForInfluencer +
          '/' +
          influencerId
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const removeTagsForInfluencer = (tagId, influencerId) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url +
          import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT +
          Api_routes.removeTagsForInfluencer +
          '/' +
          tagId +
          '/' +
          influencerId
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

const addBulkTagsToInfluencers = (body) => {
  return new Promise(async (resolve, reject) => {
    try {
      const response = await patchRequest(
        server_url + import.meta.env.REACT_APP_DASHBOARD_SERVER_PORT + Api_routes.addBulkTagsToInfluencers,
        body
      );
      resolve(response);
    } catch (err) {
      console.log('err -- ', err);
      reject(err);
    }
  });
};

export {
  createTag,
  getAllTagsByUserId,
  updateTag,
  deleteTag,
  addTagForInfluencer,
  getAllTagsByInfluencerId,
  removeTagsForInfluencer,
  bulkTagInfluencers,
  addBulkTagsToInfluencers,
};
